module.exports = __webpack_public_path__ + "img/c05_uniteques_Normal_ua.f0f3b5ee.webp";